<!-- <h4 class="title">Refer Case</h4> -->
<br>


<div class="row" style="margin-left: 0px;margin-right:0px;">
    <div class="col-md-12">
      <div class="card-box">
        <!-- <h4 class="title-f">Personal Details</h4> -->
        <div class="row" style="padding: 0px 0px 23px 10px;">
          <div class="col-md-6">
            <h5 class="form-lable">Financier*:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-6">
            <h5 class="form-lable">Financier Type*:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-6">
            <h5 class="form-lable">Loan No./Account No.*:</h5>
            <input type="text" pInputText placeholder="">
            <input type="checkbox" style="width: 20px;margin-bottom: 17px;"> Show Case Details
          </div>
          <div class="col-md-6">
            <h5 class="form-lable">Refer Code*:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-6">
            <h5 class="form-lable">Unit Level*:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-6">
            <h5 class="form-lable">Last Action Code:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-6">
            <h5 class="form-lable">Unit Code*:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-6">
            <h5 class="form-lable">Unit Code*:</h5>
            <input type="text" pInputText placeholder="">
          </div>
          <div class="col-md-6">
            <h5 class="form-lable">Message*:</h5>
            <input type="textarea" pInputText placeholder="">
          </div>
         
          <div class="col-md-12 mt-20">
                <button type="button" class="btn btn-primary">Send</button>
           </div>
  
        </div>
      </div>
    </div>
  </div>